// extracted by mini-css-extract-plugin
module.exports = {"p":"P_p__1EplR"};